import { NgModule, } from "@angular/core";
import { APP_BASE_HREF } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule } from "@angular/forms";
import { HttpModule, JsonpModule } from "@angular/http";
import { TabsModule } from "ng2-bootstrap/components/tabs";
import { NgbModule }                  from "@ng-bootstrap/ng-bootstrap";
import { TooltipModule }            from "ng2-Tooltip";
import { RegistrationModule, UserHomeModule, LostCredentialsModule, WorkflowModule }
from "./modules";
import { AppComponent } from "./app.component";
import { APPROUTING } from "./app.routes";
import { HomeComponent } from "./components/home";
import { AboutComponent } from "./components/about";
import { ErrorComponent } from "./components/error";
import { LoginComponent } from "./components/login";
import { LoginDevComponent } from "./components/loginDev";
import { LogoutComponent } from "./components/logout";
import { GatewayComponent } from "./components/gateway";
import { HeaderComponent, FooterComponent } from "./components/shared";
import { HttpDataService, StorageService, CurrentUserService, UserAuthenticationService } from "./services/shared";
import { CommonUtility } from "./utils/commonUtility";
import { NgProgressModule } from "ng2-progressbar";

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    JsonpModule,
    TabsModule,
    NgbModule.forRoot(),
    RegistrationModule,
    LostCredentialsModule,
    WorkflowModule,
    UserHomeModule,
    APPROUTING,
    TooltipModule,
    NgProgressModule
  ],
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    AboutComponent,
    LoginComponent,
    GatewayComponent,
    ErrorComponent,
    LogoutComponent,
    LoginDevComponent,
  ],
  providers: [
    { provide: APP_BASE_HREF, useValue: "/" },
    HttpDataService,
    CurrentUserService,
    StorageService,
    UserAuthenticationService,
    CommonUtility
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts